interface InfoItemProps {
  label: string;
  value?: string;
  monospace?: boolean;
  children?: React.ReactNode;
}

export default function InfoItem({ label, value, monospace, children }: InfoItemProps) {
  return (
    <div className="space-y-1">
      <div className="text-sm text-muted-foreground">{label}</div>
      <div className={`text-sm ${monospace ? 'font-mono' : ''}`}>{children || value}</div>
    </div>
  );
}
